var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05398 8.65452L11.3225 2.24738C11.6967 1.91754 12.3033 1.91754 12.6775 2.24738L19.946 8.65452C20.5496 9.18661 20.1221 10.0964 19.2685 10.0964H4.73151C3.87787 10.0964 3.45037 9.18661 4.05398 8.65452Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 11.6145V20.4819H3.77143C3.34538 20.4819 3 20.8218 3 21.241C3 21.6602 3.34538 22 3.77143 22H20.2286C20.6546 22 21 21.6602 21 21.241C21 20.8218 20.6546 20.4819 20.2286 20.4819H19.2V11.6145H14.0571V20.4819H9.94286V11.6145H4.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtAlt);
export default __webpack_public_path__ + "static/media/court-alt.8b998a0cfa165b2ca88f697b251256f8.svg";
export { ForwardRef as ReactComponent };